import { absolutePath } from "./absolutePath";

export const scheduleDowngrades = {
  create: (planId: number) =>
    absolutePath(`account_subscriptions/schedule_downgrades`, {
      plan_id: planId,
    }),
  cancel: () =>
    absolutePath(`account_subscriptions/schedule_downgrades/cancel`),
};
